export const HCPCS_ACP_KEY = 'ACP';
export const HCPCS_PSY_KEY = 'PSY';
export const getMinDuration = choice => {
  if (!(choice !== null && choice !== void 0 && choice.rules)) {
    return 0;
  }

  return Number(Object.keys(choice.rules)[0]);
};
export const isDurationValidForChoice = (choice, duration) => {
  var _choice$maxTime;

  if (!(choice !== null && choice !== void 0 && choice.rules) || duration == null || Number(duration) === 0) {
    return false;
  }

  const num = Number(duration);
  const minMinute = getMinDuration(choice);
  const maxMinute = (_choice$maxTime = choice.maxTime) !== null && _choice$maxTime !== void 0 ? _choice$maxTime : null;

  if (num < minMinute) {
    return false;
  }

  if (maxMinute && num > maxMinute) {
    return false;
  }

  return true;
};
export const isIcdCompleteForLine = (menuKey, icdCodeNames, icdSection, isPalCarePatient) => {
  const hasICD = !!(icdCodeNames[menuKey] && icdCodeNames[menuKey].length);

  if (hasICD) {
    const icdArr = (icdSection[menuKey] || []).filter(x => !x.hide);
    return icdArr.length === icdCodeNames[menuKey].length;
  }

  if (isPalCarePatient) {
    return false;
  }

  if (Object.keys(icdSection).length) {
    const icdArr = (icdSection[menuKey] || []).filter(x => !x.hide);
    return icdArr.length === 0;
  }

  return true;
};
export const isHcpcsLineComplete = (choice, hcpcsDuration, icdCodeNames, icdSection, isPalCarePatient) => {
  if (!isDurationValidForChoice(choice, hcpcsDuration === null || hcpcsDuration === void 0 ? void 0 : hcpcsDuration[choice.key])) {
    return false;
  }

  return isIcdCompleteForLine(choice.key, icdCodeNames, icdSection, isPalCarePatient);
};
/** True when every selected HCPCS line has valid duration and ICD (if required). */

export const canRecordHcpcs = state => {
  const {
    hcpcsMapping,
    hcpcsDuration,
    icdCodeNames,
    icdSection,
    isPalCarePatient
  } = state;
  const keys = hcpcsMapping ? Object.keys(hcpcsMapping) : [];

  if (!keys.length) {
    return false;
  }

  return keys.every(key => isHcpcsLineComplete(hcpcsMapping[key], hcpcsDuration, icdCodeNames, icdSection, isPalCarePatient));
};
/** Controls the "+" menu only (not RECORD HCPCS). Mirrors legacy HCPCSMenu rules. */

export const shouldDisableHcpcsMenu = state => {
  var _Object$values$;

  const {
    hcpcsMapping,
    hcpcsDuration,
    icdCodeNames,
    icdSection,
    isPalCarePatient
  } = state;
  const mapKeys = hcpcsMapping ? Object.keys(hcpcsMapping) : [];

  if (!mapKeys.length) {
    return false;
  }

  if (mapKeys.length > 1) {
    return true;
  }

  const mapDuration = hcpcsDuration && Object.values(hcpcsDuration).length && Object.values(hcpcsDuration)[0] !== null;

  if (!mapDuration) {
    return true;
  }

  if (mapKeys[0].includes(HCPCS_PSY_KEY)) {
    return true;
  }

  const hasICD = icdCodeNames && Object.values(icdCodeNames).length && ((_Object$values$ = Object.values(icdCodeNames)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.length);

  if (hasICD) {
    const menuKey = mapKeys[0];
    const icdArr = (icdSection[menuKey] || []).filter(x => !x.hide);
    return icdArr.length !== icdCodeNames[menuKey].length;
  }

  if (isPalCarePatient) {
    return true;
  }

  if (Object.keys(icdSection).length) {
    const menuKey = mapKeys[0];
    const icdArr = (icdSection[menuKey] || []).filter(x => !x.hide);
    return icdArr.length > 0;
  }

  return false;
};
export const getHcpcsDurationPersistPayload = (choice, rawValue) => {
  var _choice$maxTime2;

  if (!(choice !== null && choice !== void 0 && choice.rules) || !Object.keys(choice.rules).length) {
    return null;
  }

  const minDuration = getMinDuration(choice);
  const maxMinute = (_choice$maxTime2 = choice.maxTime) !== null && _choice$maxTime2 !== void 0 ? _choice$maxTime2 : null;
  const targetValue = Number(rawValue);

  if (!targetValue || Number.isNaN(targetValue)) {
    return {
      key: choice.key,
      duration: null
    };
  }

  if (targetValue >= minDuration && (!maxMinute || targetValue <= maxMinute)) {
    return {
      key: choice.key,
      duration: targetValue
    };
  }

  if (targetValue > 0 && targetValue < minDuration) {
    return {
      key: choice.key,
      duration: null
    };
  }

  return {
    key: choice.key,
    duration: null
  };
};